import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon4 } from "../../assets/icons/Fork4.svg";
import { ReactComponent as ForkIcon5 } from "../../assets/icons/Fork5.svg";

import { ReactComponent as LinkIcon } from "../../assets/icons/marketing/linkIcon.svg";
import { ReactComponent as RefferalIcon } from "../../assets/icons/marketing/refferalIcon.svg";
import { ReactComponent as CampaignIcon } from "../../assets/icons/marketing/campaign.svg";
import { ReactComponent as MessagingIcon } from "../../assets/icons/marketing/messaging.svg";
import { ReactComponent as ExportIcon } from "../../assets/icons/marketing/export.svg";
import MarketingDataIcon from "../../assets/imgs/marketing/advantages.webp";


const MarketingData = () => {
  const block1 = [
    {
      title: "True Multi-Touch Attribution",
      description:
        "Understand every step of the user journey—across ads, platforms, and devices—with real-time tracking you can act on.",
    },

    {
      title: "High-Converting Smart Links",
      description:
        "Deep links that adapt to device and context, guiding users directly to the content that converts.",
    },

    {
      title: "Automated Messaging That Performs",
      description:
        "Send targeted push, in-app, or inbox messages that re-engage users—without engineering help.",
    },

    {
      title: "Real-Time Attribution",
      description:
        "See performance in real time, compare campaigns, and make fast decisions based on real data, not gut feelings.",
    },
  ];
  const block2 = [
    {
      title: "Deep Linking & Deferred Deep Links",
      description:
        "Send users directly to the content they care about—on web, iOS, or Android.",
      icon: <LinkIcon />,
    },

    {
      title: "Referral Tracking",
      description: "Track every referral and reward advocates with confidence.",
      icon: <RefferalIcon />,
    },

    {
      title: "Campaign-Level Insights",
      description: "Break down ROI by source, channel, and audience segment.",
      icon: <CampaignIcon />,
    },

    {
      title: "In-App & Cross-App Messaging",
      description:
        "Reach users with timely, personalized messages that drive action.",
      icon: <MessagingIcon />,
    },
    {
      title: "Full Export & API Access",
      description:
        "Feed your data stack, automate reporting, and build custom dashboards.",
      icon: <ExportIcon />,
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"marketingData"}>
        <Content>
          <TextWrapper>
            <Title>Why Marketing Teams Choose Grovs? </Title>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon4 color="rgba(66, 0, 0, 0.55)" />
            </ForkWrapper>

            <ItemsWrapper>
              {block1.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>Purpose-Built Features for Marketing Growth </Title>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon5 color="rgba(66, 0, 0, 0.55)" />
            </ForkWrapper>

            <ItemsWrapper>
              {block2.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  icon={item.icon}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>See What Better Marketing Looks Like</Title>
            <Subtitle>
              {" "}
              Grovs makes it simple to drive higher ROI, boost engagement, and
              increase conversions with ease.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <CardWrapper
            >
              <ImageContainer>
                <img src={MarketingDataIcon} alt='analytics-white' />

              </ImageContainer>
            </CardWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default MarketingData;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
 gap: 20px;
  overflow: hidden;

`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
  overflow: hidden;
`;
const ForkWrapper = styled.div`
display:flex;
align-items:center;
height:100%;
  @media (max-width: 990px) {
    display: none;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  overflow: hidden;
`;
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: hidden;
  width: 100%;

img {
    display: flex;
object-fit:cover;
    height: 100%;
    width: 100%;
   
  }
`;
